import { facetDeselect, facetExclude, facetSelect, facetUnexclude, logFacetDeselect, logFacetExclude, logFacetSelect, logFacetUnexclude, } from './facet-set-analytics-actions.js';
export const isFacetValueSelected = (value) => {
    return value.state === 'selected';
};
export const isFacetValueExcluded = (value) => {
    return value.state === 'excluded';
};
export const getLegacyAnalyticsActionForToggleFacetSelect = (facetId, selection) => {
    const payload = {
        facetId: facetId,
        facetValue: selection.value,
    };
    return isFacetValueSelected(selection)
        ? logFacetDeselect(payload)
        : logFacetSelect(payload);
};
export const getAnalyticsActionForToggleFacetSelect = (selection) => isFacetValueSelected(selection) ? facetDeselect() : facetSelect();
export const getLegacyAnalyticsActionForToggleFacetExclude = (facetId, selection) => {
    const payload = {
        facetId: facetId,
        facetValue: selection.value,
    };
    return isFacetValueExcluded(selection)
        ? logFacetUnexclude(payload)
        : logFacetExclude(payload);
};
export const getAnalyticsActionForToggleFacetExclude = (selection) => isFacetValueExcluded(selection) ? facetUnexclude() : facetExclude();
